@if (game.currentLeague()?.type === 'PRIVATE') {
  <p class="p-5 text-sm">Los resultados privados se consultan en el calendario. Esta pantalla de simulación y edición no está disponible para ligas privadas.</p>
} @else {
<div class="space-y-6 pb-20 sm:pb-8">
  <!-- Top Header & Matchday Cycle State (Material Surface) -->
  <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4 bg-white dark:bg-slate-900 p-5 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-xs dark:shadow-md transition-colors">
    <div>
      <div class="flex items-center space-x-2">
        <h2 class="text-xl font-bold text-slate-900 dark:text-white">{{ game.t('matches.title') }}</h2>
        <span class="px-2 py-0.5 rounded-lg text-xs font-semibold bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 border border-slate-200 dark:border-slate-700">
          {{ game.t('matches.simulation_badge') }}
        </span>
      </div>
      <p class="text-xs text-slate-500 dark:text-slate-400 mt-1">
        {{ game.t('matches.desc') }}
      </p>
    </div>

    <!-- Batch Processing Status Badge -->
    <div class="flex items-center space-x-2">
      <span class="inline-flex items-center space-x-1.5 px-3 py-1.5 rounded-xl text-xs font-semibold bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 border border-slate-200 dark:border-slate-700">
        <app-icon name="clock" [size]="14" class="text-slate-400" />
        <span>{{ game.t('matches.batch_info') }}</span>
      </span>
    </div>
  </div>

  <!-- Matchday Lifecycle Tracker -->
  <div class="bg-white dark:bg-slate-900 p-4 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-xs transition-colors">
    <div class="text-xs font-bold text-slate-700 dark:text-slate-400 uppercase tracking-wider mb-3">
      {{ game.t('matches.phases_title') }}
    </div>
    <div class="grid grid-cols-2 sm:grid-cols-4 gap-2 text-center text-xs">
      <!-- Phase 1: OPEN -->
      <div
        class="p-2.5 rounded-xl border transition-colors"
        [ngClass]="game.currentMatchday().status === 'OPEN' ? 'bg-emerald-50 border-emerald-300 text-emerald-800 font-bold dark:bg-emerald-950/60 dark:border-emerald-500 dark:text-emerald-300' : 'bg-slate-50 dark:bg-slate-950/40 border-slate-200 dark:border-slate-800 text-slate-500 dark:text-slate-400'"
      >
        <div class="text-[10px] uppercase">{{ game.t('matches.phase') }} 1</div>
        <div class="text-sm font-bold">OPEN</div>
        <div class="text-[10px] mt-0.5">{{ game.t('matches.lineup_open') }}</div>
      </div>

      <!-- Phase 2: LOCKED -->
      <div
        class="p-2.5 rounded-xl border transition-colors"
        [ngClass]="game.currentMatchday().status === 'LOCKED' ? 'bg-amber-50 border-amber-300 text-amber-800 font-bold dark:bg-amber-950/60 dark:border-amber-500 dark:text-amber-300' : 'bg-slate-50 dark:bg-slate-950/40 border-slate-200 dark:border-slate-800 text-slate-500 dark:text-slate-400'"
      >
        <div class="text-[10px] uppercase">{{ game.t('matches.phase') }} 2</div>
        <div class="text-sm font-bold">LOCKED</div>
        <div class="text-[10px] mt-0.5">{{ game.t('matches.lineup_frozen') }}</div>
      </div>

      <!-- Phase 3: SCORED -->
      <div
        class="p-2.5 rounded-xl border transition-colors"
        [ngClass]="game.currentMatchday().status === 'SCORED' ? 'bg-blue-50 border-blue-300 text-blue-800 font-bold dark:bg-blue-950/60 dark:border-blue-500 dark:text-blue-300' : 'bg-slate-50 dark:bg-slate-950/40 border-slate-200 dark:border-slate-800 text-slate-500 dark:text-slate-400'"
      >
        <div class="text-[10px] uppercase">{{ game.t('matches.phase') }} 3</div>
        <div class="text-sm font-bold">SCORED</div>
        <div class="text-[10px] mt-0.5">{{ game.t('matches.points_calculated') }}</div>
      </div>

      <!-- Phase 4: CLOSED -->
      <div
        class="p-2.5 rounded-xl border transition-colors"
        [ngClass]="game.currentMatchday().status === 'CLOSED' ? 'bg-purple-50 border-purple-300 text-purple-800 font-bold dark:bg-purple-950/60 dark:border-purple-500 dark:text-purple-300' : 'bg-slate-50 dark:bg-slate-950/40 border-slate-200 dark:border-slate-800 text-slate-500 dark:text-slate-400'"
      >
        <div class="text-[10px] uppercase">{{ game.t('matches.phase') }} 4</div>
        <div class="text-sm font-bold">CLOSED</div>
        <div class="text-[10px] mt-0.5">{{ game.t('matches.round_closed') }}</div>
      </div>
    </div>
  </div>

  <!-- Navigation Sub-Tabs -->
  <div class="flex bg-slate-100 dark:bg-slate-900 p-1 rounded-xl border border-slate-200 dark:border-slate-800 space-x-1">
    <button
      (click)="activeSubTab = 'editorial'"
      class="flex items-center space-x-2 px-3.5 py-2 rounded-lg text-xs font-semibold transition-all cursor-pointer"
      [ngClass]="activeSubTab === 'editorial' ? 'bg-emerald-600 text-white shadow-xs' : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white'"
    >
      <app-icon name="award" [size]="16" />
      <span>{{ game.t('matches.press_ratings') }}</span>
    </button>

    <button
      (click)="activeSubTab = 'engine'"
      class="flex items-center space-x-2 px-3.5 py-2 rounded-lg text-xs font-semibold transition-all cursor-pointer"
      [ngClass]="activeSubTab === 'engine' ? 'bg-emerald-600 text-white shadow-xs' : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white'"
    >
      <app-icon name="shield" [size]="16" />
      <span>{{ game.t('matches.performance_mods') }}</span>
    </button>
  </div>

  <!-- SUBTAB 1: Editorial Performance Backoffice -->
  @if (activeSubTab === 'editorial') {
    <div class="bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 p-5 space-y-4 shadow-xs transition-colors">
      <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-3 border-b border-slate-100 dark:border-slate-800 pb-3">
        <div>
          <h3 class="text-base font-bold text-slate-900 dark:text-white">{{ game.t('matches.editorial_title') }}</h3>
          <p class="text-xs text-slate-500 dark:text-slate-400">
            {{ game.t('matches.editorial_desc') }}
          </p>
        </div>

        <button
          (click)="game.publishEditorialRatings()"
          class="flex items-center space-x-1.5 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 text-white text-xs font-semibold rounded-xl shadow-xs transition-all cursor-pointer active:scale-98"
        >
          <app-icon name="check-circle" [size]="16" />
          <span>{{ game.t('matches.publish_ratings') }}</span>
        </button>
      </div>

      <div class="overflow-x-auto rounded-xl border border-slate-200 dark:border-slate-800">
        <table class="w-full text-left text-xs">
          <thead class="bg-slate-50 dark:bg-slate-950 text-slate-600 dark:text-slate-400 font-bold uppercase text-[10px] border-b border-slate-200 dark:border-slate-800">
            <tr>
              <th class="py-2.5 px-3">{{ game.t('matches.col_player') }}</th>
              <th class="py-2.5 px-2 text-center">{{ game.t('matches.col_pos') }}</th>
              <th class="py-2.5 px-3 text-center">{{ game.t('matches.col_press_stars') }}</th>
              <th class="py-2.5 px-2 text-center">{{ game.t('matches.col_goals') }}</th>
              <th class="py-2.5 px-2 text-center">{{ game.t('matches.col_yellows') }}</th>
              <th class="py-2.5 px-2 text-center">{{ game.t('matches.col_reds') }}</th>
              <th class="py-2.5 px-3 text-right">{{ game.t('matches.col_fantasy_pts') }}</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-slate-100 dark:divide-slate-800/60 font-medium">
            @for (rate of game.editorialRatings(); track rate.playerId) {
              <tr class="hover:bg-slate-50 dark:hover:bg-slate-800/40 transition-colors">
                <td class="py-2.5 px-3">
                  <span class="font-bold text-slate-900 dark:text-white">{{ rate.playerName }}</span>
                </td>
                <td class="py-2.5 px-2 text-center text-[10px] font-bold text-slate-500 dark:text-slate-400">
                  {{ rate.position }}
                </td>
                <td class="py-2.5 px-3 text-center">
                  <div class="inline-flex items-center space-x-1 bg-slate-50 dark:bg-slate-950 px-2 py-1 rounded-lg border border-slate-200 dark:border-slate-800">
                    @for (star of [1, 2, 3, 4, 5]; track star) {
                      <button
                        (click)="updateStars(rate, star)"
                        class="text-xs transition-colors cursor-pointer"
                        [ngClass]="star <= rate.baseRating ? 'text-amber-500' : 'text-slate-300 dark:text-slate-600 hover:text-slate-500'"
                      >
                        ★
                      </button>
                    }
                  </div>
                </td>
                <td class="py-2.5 px-2 text-center">
                  <div class="inline-flex items-center space-x-1">
                    <button
                      (click)="changeGoals(rate, -1)"
                      class="w-5 h-5 rounded bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 font-bold hover:bg-slate-200 dark:hover:bg-slate-700 cursor-pointer"
                    >
                      -
                    </button>
                    <span class="w-6 font-mono font-bold text-slate-900 dark:text-white">{{ rate.goals }}</span>
                    <button
                      (click)="changeGoals(rate, 1)"
                      class="w-5 h-5 rounded bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 font-bold hover:bg-slate-200 dark:hover:bg-slate-700 cursor-pointer"
                    >
                      +
                    </button>
                  </div>
                </td>
                <td class="py-2.5 px-2 text-center">
                  <div class="inline-flex items-center space-x-1">
                    <button
                      (click)="changeYellow(rate, -1)"
                      class="w-5 h-5 rounded bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 font-bold hover:bg-slate-200 dark:hover:bg-slate-700 cursor-pointer"
                    >
                      -
                    </button>
                    <span class="w-6 font-mono font-bold text-amber-600 dark:text-amber-400">{{ rate.yellowCards }}</span>
                    <button
                      (click)="changeYellow(rate, 1)"
                      class="w-5 h-5 rounded bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 font-bold hover:bg-slate-200 dark:hover:bg-slate-700 cursor-pointer"
                    >
                      +
                    </button>
                  </div>
                </td>
                <td class="py-2.5 px-2 text-center">
                  <button
                    (click)="toggleRed(rate)"
                    class="px-2 py-0.5 rounded text-[10px] font-bold border transition-colors cursor-pointer"
                    [ngClass]="rate.redCards > 0 ? 'bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-950 dark:text-rose-300 dark:border-rose-800' : 'bg-slate-50 dark:bg-slate-950 text-slate-500 dark:text-slate-400 border-slate-200 dark:border-slate-800 hover:text-slate-700'"
                  >
                    {{ rate.redCards > 0 ? game.t('matches.sent_off') : game.t('matches.not_sent_off') }}
                  </button>
                </td>
                <td class="py-2.5 px-3 text-right font-mono font-bold text-sm text-emerald-700 dark:text-emerald-400">
                  {{ calculatePreviewPoints(rate) }} pts
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }

  <!-- SUBTAB 2: Match Engine & Performance Modifiers -->
  @if (activeSubTab === 'engine') {
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div class="bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 p-5 space-y-4 shadow-xs transition-colors">
        <h3 class="text-base font-bold text-slate-900 dark:text-white">{{ game.t('matches.tactical_mods_title') }}</h3>
        <p class="text-xs text-slate-500 dark:text-slate-400">
          {{ game.t('matches.tactical_mods_desc') }}
        </p>

        <div class="space-y-3 text-xs pt-2">
          <div class="p-3 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200 dark:border-slate-800 flex justify-between items-center">
            <div>
              <div class="font-bold text-slate-900 dark:text-white">{{ game.t('matches.mod_staff') }}</div>
              <div class="text-[11px] text-slate-500 dark:text-slate-400">{{ game.t('matches.mod_staff_desc') }}</div>
            </div>
            <span class="font-bold text-emerald-700 dark:text-emerald-400 font-mono text-sm">+{{ staffModPercent() }}%</span>
          </div>

          <div class="p-3 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200 dark:border-slate-800 flex justify-between items-center">
            <div>
              <div class="font-bold text-slate-900 dark:text-white">{{ game.t('matches.mod_attendance') }}</div>
              <div class="text-[11px] text-slate-500 dark:text-slate-400">{{ game.t('matches.mod_attendance_desc') }}</div>
            </div>
            <span class="font-bold text-emerald-700 dark:text-emerald-400 font-mono text-sm">+{{ attendanceModPercent() }}%</span>
          </div>

          <div class="p-3 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200 dark:border-slate-800 flex justify-between items-center">
            <div>
              <div class="font-bold text-slate-900 dark:text-white">{{ game.t('matches.mod_momentum') }}</div>
              <div class="text-[11px] text-slate-500 dark:text-slate-400">{{ game.t('matches.mod_momentum_desc') }}</div>
            </div>
            <span class="font-bold text-emerald-700 dark:text-emerald-400 font-mono text-sm">+{{ momentumModPercent() }}%</span>
          </div>

          <!-- Modificador Táctico de Entrenador (Congelado al inicio de la jornada) -->
          <div class="p-3 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200 dark:border-slate-800 space-y-2">
            <div class="flex justify-between items-center">
              <div>
                <div class="font-bold text-slate-900 dark:text-white flex items-center space-x-1.5">
                  <app-icon name="user" [size]="14" class="text-emerald-600 dark:text-emerald-400" />
                  <span>Entrenador (Modificador Táctico Congelado)</span>
                </div>
                <div class="text-[11px] text-slate-500 dark:text-slate-400">
                  @if (frozenCoach(); as fc) {
                    {{ fc.name }} · Bonificación por líneas congelada al inicio de jornada
                  } @else {
                    Sin entrenador congelado en el partido (+0% neutral)
                  }
                </div>
              </div>
              @if (frozenCoach(); as fc) {
                <div class="text-right">
                  <span class="font-bold text-emerald-700 dark:text-emerald-400 font-mono text-xs">
                    ATK +{{ fc.attack }}% · MED +{{ fc.midfield }}% · DEF +{{ fc.defense }}%
                  </span>
                </div>
              } @else {
                <span class="font-bold text-slate-400 font-mono text-xs">+0.0%</span>
              }
            </div>
            <div class="pt-1.5 border-t border-slate-200/60 dark:border-slate-800/80 text-[10px] text-slate-400 space-y-0.5">
              <p>• {{ game.t('coaches.match_frozen_notice') }}</p>
              <p>• {{ game.t('coaches.match_included_notice') }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- User fixture match summary -->
      <div class="bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 p-5 space-y-4 shadow-xs transition-colors">
        <h3 class="text-base font-bold text-slate-900 dark:text-white">{{ game.t('matches.user_fixture_title') }} {{ game.currentMatchdayNumber() }}</h3>

        @if (userFixture(); as fix) {
          <div class="p-5 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200 dark:border-slate-800 space-y-4 text-center">
            <div class="flex items-center justify-center space-x-6">
              <div class="text-right flex-1">
                <div class="text-base font-bold text-slate-900 dark:text-white">{{ getClubName(fix.homeClubId) }}</div>
                <div class="text-[10px] text-slate-500 dark:text-slate-400">{{ game.t('matches.home_label') }}</div>
              </div>

              <div class="px-4 py-2 bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800 shadow-xs">
                @if (fix.played) {
                  <span class="text-2xl font-bold font-mono text-emerald-700 dark:text-emerald-400">
                    {{ fix.homeScore }} - {{ fix.awayScore }}
                  </span>
                } @else {
                  <span class="text-sm font-mono text-slate-400 font-semibold">VS</span>
                }
              </div>

              <div class="text-left flex-1">
                <div class="text-base font-bold text-slate-900 dark:text-white">{{ getClubName(fix.awayClubId) }}</div>
                <div class="text-[10px] text-slate-500 dark:text-slate-400">{{ game.t('matches.away_label') }}</div>
              </div>
            </div>

            @if (fix.played && fix.engineCalculation) {
              <div class="pt-3 border-t border-slate-200 dark:border-slate-800 text-xs text-left space-y-2">
                <div class="flex justify-between text-slate-500 dark:text-slate-400">
                  <span>{{ game.t('matches.recorded_attendance') }}:</span>
                  <strong class="text-slate-900 dark:text-white font-mono">{{ fix.engineCalculation.attendanceCalculated.toLocaleString() }} {{ game.t('matches.spectators_suffix') }}</strong>
                </div>
                <div class="flex justify-between text-slate-500 dark:text-slate-400">
                  <span>{{ game.t('matches.ticket_collection') }}:</span>
                  <strong class="text-emerald-700 dark:text-emerald-400 font-mono">{{ (fix.engineCalculation.ticketRevenueM).toFixed(3) }} M€</strong>
                </div>

                @if (fix.engineCalculation.goalScorers.length > 0) {
                  <div class="pt-2">
                    <div class="text-[11px] font-bold text-slate-500 dark:text-slate-400 uppercase mb-1">{{ game.t('matches.match_goals') }}:</div>
                    <div class="space-y-1">
                      @for (g of fix.engineCalculation.goalScorers; track $index) {
                        <div class="text-slate-700 dark:text-slate-300">⚽ {{ g.playerName }} ({{ g.minute }}')</div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</div>

}
